// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marginLeft200 {
  margin-left: 200px;
}

.initialResults {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 10%;
}

.memberProfileInfoDiv {
    display: flex;
    flex-direction: column;
    text-align: center;
    cursor: pointer;
}

.marginRight20 {
    margin-right: 20px;
}

.width100 {
    width: 100%;
}

.marginTop25 {
    margin-top: 25px;
}

.marginLeft10 {
    margin-left: 10px;
}

.marginLeft200 {
    margin-left: 200px;
}

.displayInline {
    display: inline;
}

.buttonDivDetailedView {
    display: flex;
    margin-left: 140px;
    margin-bottom: 20px;
}

.sideNavCloseButton {
    position: absolute;
    top: 0;
    font-size: 40px;
    cursor: pointer;
    margin-right: 56px;
    left: 300px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Member.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf","sourcesContent":[".marginLeft200 {\n  margin-left: 200px;\n}\n\n.initialResults {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    margin-top: 10%;\n}\n\n.memberProfileInfoDiv {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    cursor: pointer;\n}\n\n.marginRight20 {\n    margin-right: 20px;\n}\n\n.width100 {\n    width: 100%;\n}\n\n.marginTop25 {\n    margin-top: 25px;\n}\n\n.marginLeft10 {\n    margin-left: 10px;\n}\n\n.marginLeft200 {\n    margin-left: 200px;\n}\n\n.displayInline {\n    display: inline;\n}\n\n.buttonDivDetailedView {\n    display: flex;\n    margin-left: 140px;\n    margin-bottom: 20px;\n}\n\n.sideNavCloseButton {\n    position: absolute;\n    top: 0;\n    font-size: 40px;\n    cursor: pointer;\n    margin-right: 56px;\n    left: 300px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
